module.exports = __webpack_public_path__ + "PriyankaWakchaure-e3e0f916.webp";